/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EnrollmentDocumentManagementRepositoryResponse } from "../types/EnrollmentDocumentManagementRepositoryResponse.ts";

export const enrollmentDocumentManagementRepositoryResponseSchema = z.object({
  id: z.optional(z.number().int().describe("ID do documento de matrícula.")),
  documentName: z
    .string()
    .describe("Nome do documento de matrícula.")
    .nullish(),
  active: z.optional(
    z.boolean().describe("Indica se o documento de matrícula está ativo."),
  ),
}) as unknown as ToZod<EnrollmentDocumentManagementRepositoryResponse>;
